export type ImageFormat =
    | '24_24-3x'
    | '32_32-3x'
    | '48_48-3x'
    | '64_64'
    | '64_64-3x'
    | '70_70'
    | '80_80-3x'
    | '96_96'
    | '120_120'
    | '120_120_v2'
    | '150_150'
    | '288_168'
    | '290_163'
    | '352_352'
    | '400_400'
    | '768_768'
    | '250_250'
    | '352_352'
    | '393_125'
    | '393_125-2x'
    | '600_600-2x'
    | '1280_300'
    | '1000_750_inset-2x'

export const formatImageUrl = (url: string, format: ImageFormat): string => url.replace('{format}', format)
